module.exports = __webpack_public_path__ + "img/collection-engagementRingsSolitaire@2x.9b2a617.webp";